import { useEffect } from 'react';

const useScript = (url: string, id: string): void => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.id = id;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, id]);
};

export default useScript;
